import { IMenu } from "../../interfaces/menu";
import { PermissionService } from "../permission/permission.service";

/**
 * Filtre un menu selon les permissions de l'utilisateur
 * @param menu - Le menu à filtrer
 * @param userRole - Le rôle de l'utilisateur
 * @param userSpace - L'espace de l'utilisateur
 * @param permissionService - Le service de permissions (optionnel)
 * @returns Le menu filtré
 */
function filterMenuByPermissions(menu: IMenu[], userRole: string, userSpace: string | number, permissionService?: PermissionService): IMenu[] {
    // Convertir l'espace de l'utilisateur en chaîne pour la comparaison
    const userSpaceStr = String(userSpace);

    return menu.filter(item => {
        // Vérifier si l'élément est caché
        if (item.hidden) return false;

        // NOUVEAU : Vérifier la clé de permission si elle existe et si le service est fourni
        if (item.permissionKey && permissionService) {
            if (!permissionService.hasPermission(item.permissionKey)) {
                return false;
            }
        } else {
            // Ancienne logique (fallback)
            // Vérifier les rôles autorisés
            if (item.roles && item.roles.length > 0 && !item.roles.includes(userRole)) {
                return false;
            }

            // Vérifier les espaces autorisés
            if (item.spaces && item.spaces.length > 0 && !item.spaces.includes(userSpaceStr)) {
                return false;
            }
        }

        // Filtrer récursivement les enfants
        if (item.children && item.children.length > 0) {
            item.children = filterMenuByPermissions(item.children, userRole, userSpace, permissionService);
            // Si tous les enfants sont filtrés, masquer le parent
            if (item.children.length === 0) {
                return false;
            }
        }

        return true;
    });
}



export const MENU: IMenu[] = [

    // MENU ACCUEIL
    {
        headTitle: 'accueil',
    },
    {
        title: 'accueil',
        icon: 'layout-dashboard',
        active: true,
        path: '/dashboard',
        type: 'link',
    },


    // MENU PRODUCTIONS
    {
        headTitle: 'productions',
        permissionKey: 'isContracts',
    },
    {
        title: 'automobile',
        icon: 'car',
        type: 'link',
        active: true,
        permissionKey: 'isContracts',
        path: '/contracts/auto/list'
    },
    {
        title: 'assurances de personnes',
        icon: 'heart-plus',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isContracts',
        children: [
            {
                title: 'assurance santé',
                type: 'link',
                active: true,
                path: '/contracts/health/list'
            },
            {
                title: 'assistance',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/assistance/list'

            },
            {
                title: 'individuel accident',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/accident/list'
            },
            {
                title: 'assurance voyage',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/travel/list'
            },
        ]
    },
    {
        title: 'risques divers',
        icon: 'shield-plus',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isContracts',
        children: [
            {
                title: 'incendie',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/fire/list'
            },
            {
                title: 'responsabilité civile',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/civil/list'
            },
            {
                title: 'caution',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/deposit/list'
            },
            {
                title: 'transport',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/transport/list'
            },
            {
                title: 'bris de machine',
                type: 'link',
                active: true,
                path: '/contracts/miscellaneous-risks/machine/list'
            }
        ]
    },


    // MENU DEMANDES
    {
        headTitle: 'demandes',
        permissionKey: 'isRequests',
    },
    {
        title: 'demandes internes',
        icon: 'file-question',
        type: 'link',
        active: true,
        permissionKey: 'isRequestsInternal',
        path: '/requests/internal/list',
    },
    // {
    //     title: 'demandes externes',
    //     icon: 'file-question',
    //     type: 'link',
    //     active: true,
    //     permissionKey: 'isRequestsExternal',
    //     path: '/requests/external/list',
    // },


    // MENU SINISTRES
    {
        headTitle: 'sinistres',
        permissionKey: 'isSinisters',
    },
    {
        title: 'sinistre auto',
        icon: 'wrench',
        type: 'link',
        active: true,
        permissionKey: 'isSinisters',
        path: '/sinisters/auto/list',
    },
    {
        title: 'sinistre santé',
        icon: 'heart-pulse',
        type: 'link',
        active: true,
        permissionKey: 'isSinisters',
        path: '/sinisters/health/list',
    },
    {
        title: 'sinistre risques divers',
        icon: 'alert-triangle',
        type: 'link',
        active: true,
        permissionKey: 'isSinisters',
        path: '/sinisters/risk/list',
    },


    // MENU COTATIONS
    {
        headTitle: 'cotations',
        permissionKey: 'isQuotations',
    },
    {
        title: 'cotation automobile',
        icon: 'clipboard-list',
        type: 'sub',          // Devient un menu déroulant
        Menusub: true,
        active: false,
        permissionKey: 'isQuotationsAuto',
        children: [
            { path: '/quotations/mono/folder', title: 'mono-véhicule', type: 'link', permissionKey: 'isQuotationMono' },
            { path: '/quotations/fleet/folder', title: 'flotte automobile', type: 'link', permissionKey: 'isQuotationFleet' }
        ]
    },
    // {
    //     title: 'cotation multirisque',
    //     icon: 'house',
    //     type: 'sub',
    //     Menusub: true,
    //     active: false,
    //     permissionKey: 'isQuotationMultirisk',
    //     children: [
    //         {path: '/quotations/multirisk/folder', title: 'multirisque habitation', type: 'link'},
    //         // {path: '/quotations/multirisk/add', title: 'ajouter une cotation', type: 'link'},
    //     ]
    // },
    // {
    //     title: 'cotation voyage',
    //     icon: 'plane',
    //     type: 'link',
    //     active: true,
    //     permissionKey: 'isQuotationTravel',
    //     path: '/quotations/travel/folder',
    // },



    // MENU COMPTABILITE
        {
        headTitle: 'Comptabilité',
        permissionKey: 'isAccounting',
    },
    {
        title: 'Assureurs',
        icon: 'building-2',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isCommissionsInsurers',
        children: [
            {path: '/commissions/list', title: 'liste des assureurs', type: 'link'},
            {path: '/commissions/brokers-fees', title: 'liste des commissions', type: 'link'},
            // {path: '', title: 'Liste des objectifs', type: 'link', permissionKey: 'isTargetsInsurers'},
        ]
    },
    {
        title: 'apporteurs',
        icon: 'handshake',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isCommissionsProducers',
        children: [
            { path: '/providers/list', title: 'liste des apporteurs', type: 'link' },
            // { path: '/commissions/providers-fees', title: 'liste des commissions', type: 'link' },
            { path: '/providers/list-target', title: 'liste des objectifs', type: 'link', permissionKey: 'isTargetsProviders' },
        ]
    },
    {
        title: 'clients',
        icon: 'users',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isClients',
        children: [
            { path: '/clients/list', title: 'liste des clients', type: 'link' },
            { path: '/clients/premiums', title: 'liste des primes', type: 'link' },
            { path: '/clients/tokens', title: 'liste des accès', type: 'link', permissionKey: 'isToken' },
        ]
    },





    // MENU STATISTIQUES
    {
        headTitle: 'statistiques',
        permissionKey: 'isStatistics',
    },
    {
        title: 'production',
        icon: 'bar-chart-2',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isStatistics',
        children: [
            { path: '/statistics/list', title: 'production globale', type: 'link' },
            { path: '/all-vehicles/list', title: 'liste des vehicules', type: 'link', permissionKey: 'isVehicles' },
        ]
    },
    {
        title: 'transactions',
        icon: 'arrow-left-right',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isTransactions',
        children: [
            { path: '/transactions/list-assurer', title: 'transactions assureurs', type: 'link', permissionKey: 'isCommissionsInsurers' },
            { path: '/transactions/list-client', title: 'transactions clients', type: 'link', permissionKey: 'isClients' },
        ]
    },



    // MENU PROSPECTIONS
    {
        headTitle: 'prospects',
        permissionKey: 'isLeads',
    },
    {
        title: 'prospects',
        icon: 'user-plus',
        type: 'link',
        active: true,
        permissionKey: 'isLeads',
        path: '/leads/list',
    },
    {
        title: 'opportunités',
        icon: 'target',
        type: 'link',
        active: true,
        permissionKey: 'isOpportunities',
        path: '/opportunities/list',
    },



    // MENU REFERENTIEL
    {
        headTitle: 'configuration',
        permissionKey: 'isConfiguration',
    },
    {
        title: 'marque de véhicule',
        icon: 'bookmark-check',
        type: 'link',
        active: true,
        permissionKey: 'isVehiclesBrands',
        path: '/vehicles/list',
    },
    {
        title: 'catégories',
        icon: 'package',
        type: 'link',
        active: true,
        permissionKey: 'isCategories',
        path: '/categories/list',
    },
    {
        title: 'branches',
        icon: 'git-branch',
        type: 'link',
        active: true,
        permissionKey: 'isBranches',
        path: '/branches/list',
    },
    {
        title: 'formules',
        icon: 'shield',
        type: 'link',
        active: true,
        permissionKey: 'isFormulas',
        path: '/formulas/list',
    },
    {
        title: 'assureurs',
        icon: 'award',
        type: 'link',
        active: true,
        permissionKey: 'isInsurers',
        path: '/insurers/list',
    },
    {
        title: 'conventions',
        icon: 'briefcase',
        type: 'link',
        active: true,
        permissionKey: 'isAgreements',
        path: '/agreements/list',
    },
    {
        title: 'cotations',
        icon: 'settings-2',
        type: 'sub',
        Menusub: true,
        active: false,
        permissionKey: 'isParameters',
        children: [
            { path: '/parameters/mono', title: 'cotation auto mono', type: 'link' },
            { path: '/parameters/fleet', title: 'cotation auto flotte', type: 'link' },
        ]
    },



    // MENU ADMINISTRATION
    {
        headTitle: 'administration',
        permissionKey: 'isAdministration',
    },
    {
        title: 'utilisateurs',
        icon: 'users',
        type: 'link',
        active: true,
        permissionKey: 'isUsers',
        path: '/users/list',
    },
    {
        title: 'exercices',
        icon: 'calendar',
        type: 'link',
        active: true,
        permissionKey: 'isExercices',
        path: '/exercices/list',
    },
    {
        title: 'feedback',
        icon: 'message-square',
        type: 'link',
        active: true,
        permissionKey: 'isFeedback',
        path: '/feedback/list',
    },


    {
        type: 'help',
    }
];

/**
 * Retourne le menu approprié selon le rôle de l'utilisateur
 * @param roleName - Le nom du rôle de l'utilisateur
 * @param space - L'espace de l'utilisateur
 * @returns Le menu correspondant au rôle
 */

export function getMenuByRole(roleName: string, space: string | number, permissionService?: PermissionService): IMenu[] {
    return filterMenuByPermissions(MENU, roleName, space, permissionService);
}

